import React, { Component } from 'react'



export default class VideoPlayer extends Component {
   
    constructor(props)
    {
        super(props);
        this.state={
            videoUrl: '',
            videoTitle: '',
            videoDescription: '',
            videoDate: '',
            video:null,
            videoDetails:'',
            videoPlaying:true,
            fullScreen:true
        }
        var video = this.props.location.state.video;
        var vidVideo = video.video;
        video = {video, vidVideo};
        
        var videoDetails = this.props.location.state.video;
        var videoPart = videoDetails.video;
        var video = {...videoDetails,...videoPart};
       console.log("created",video);
        this.list={
            content: "Anika Rabbani",
            creationDate: "2020-10-21 15:25:49",
            description: "Anika Rabbani'r ekti Live Session e aamontron",
            heartCount: "",
            language: "English",
            likesCount: "",
            previewImage: "http://223.30.211.125:8080/bcms/downloadAPI.do?params=60SRPFdwbrqrF%2FI23AAJBogM6WbF2zJWO8n%2BmX2RUBM1zLwoO8fwwQB5b3sUrXxVIbFO09czmbXt%0AE1HaUWOEOeMh6Xuc2QwfEj1nXQ8bmQswY6A1yzYacf24g%2F38d9B5awYzXJyYIvINActrrGHY7gkM%0Ayni2TXHLa1KurfjnVrAHv5KVg8NJI1qw8ZCD9YatE30zT8euY2xUHsoelkvs%2FehnxGOAiVyEg3kA%0AAiZxyMZ5ZvY0NZWbH7avYPXOe%2B6mItveuHj2meHo1q3L9f6yqTZqmh2BuO4PWSnhvu%2FYCCwG3IK5%0AQGp5qcp2Kp59Aur05p8Ve13onEDYf3MOcSWWL9EGP4%2FEn0Bk%2BKFAgWX2Z4g%3D",
            releaseYear: "-00:34",
            title: "Anika Rabbani",
            validTo: "2040-10-21 15:25:49",
            validfrom: "2020-10-21 15:25:49",
            duration: "00:34",
            encoding: "mp4",
            feed: "http://223.30.211.125:8080/bcms/downloadAPI.do?params=60SRPFdwbrqrF%2FI23AAJBogM6WbF2zJWO8n%2BmX2RUBM1zLwoO8fwwQB5b3sUrXxVIbFO09czmbXt%0AE1HaUWOEOeMh6Xuc2QwfEj1nXQ8bmQswY6A1yzYacf24g%2F38d9B5awYzXJyYIvINActrrGHY7gkM%0Ayni2TXHLa1KurfjnVrAHv5KVg8NJI1qw8ZCD9YatE30zT8euY2xUHsoelkvs%2FehnxGOAiVyEg3kA%0AAiZxyMZ5ZvY0NZWbH7avYPXOe%2B6mItveuHj2meHo1q3L9f6yqTZqmh2BuO4PWSnhvu%2FYCCwG3IK5%0AQGp5qcp2Kp59Aur0zcN%2FD7VvdKCXBOoQclFKB6wPBrDJ7Nili%2BVZgq4o0TFTIdh2OiYyU0digkxZ%0AgFxG",
            filepathurl: "http://223.30.211.125:8080/bcms/downloadAPI.do?params=60SRPFdwbrqrF%2FI23AAJBogM6WbF2zJWO8n%2BmX2RUBM1zLwoO8fwwQB5b3sUrXxVIbFO09czmbXt%0AE1HaUWOEOeMh6Xuc2QwfEj1nXQ8bmQswY6A1yzYacf24g%2F38d9B5awYzXJyYIvINActrrGHY7gkM%0Ayni2TXHLa1KurfjnVrAHv5KVg8NJI1qw8ZCD9YatE30zT8euY2xUHsoelkvs%2FehnxGOAiVyEg3kA%0AAiZxyMZ5ZvY0NZWbH7avYPXOe%2B6mItveuHj2meHo1q3L9f6yqTZqmh2BuO4PWSnhvu%2FYCCwG3IK5%0AQGp5qcp2Kp59Aur0zcN%2FD7VvdKCXBOoQclFKB6wPBrDJ7Nili%2BVZgq4o0TFTIdh2OiYyU0digkxZ%0AgFxG",
            hd: "no",
            resolution: "720x480",
            videoLength: "00:34",
            viewCount: "3.2k"
            };
            console.log("existing",this.list);
            this.list=video;
            this.videoRef=React.createRef();
            this.skip = this.skip.bind(this);
            this.togglePlay = this.togglePlay.bind(this);
    }
    
    componentDidMount()
    {
        

        this.setState({
            ...this.state,
            video: this.videoRef.current
          });
        
          this.setState({
            videoUrl: this.list.filepathurl,
            videoTitle: this.list.content,
            videoDescription: this.list.description
        });
        setTimeout(()=>{this.enterFS();this.videoRef.current.play();},500);
         // debugger;
          //this.videoRef.toggleFullscreen();
    }
    skip(e) {
        const skipValue = e.target.attributes[0].value;
        if (!isNaN(skipValue)) {
         this.videoRef.current.currentTime += Number(skipValue);
        }
      }
    togglePlay() {
        this.videoRef.current.paused?  this.videoRef.current.play(): this.videoRef.current.pause();
        this.setState({
            ...this.state,
            videoPlaying:!this.state.videoPlaying
        });
    }
    playVideo(list) {
    //    $("html, body").animate({ scrollTop: 0 }, "fast");
   
        this.setState({
            videoUrl: this.list.filepathurl,
            videoTitle: this.list.content,
            videoDescription: this.list.description
        });
    }

      enterFS= () =>{
      
          let element=document.getElementById('video' +this.state.videoTitle);
          if(!element)
          return;
          console.log("Video element",element);
          if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        }
      }
 
      toggleFullScreen=()=> {
        let element=document.getElementById('video' +this.state.videoTitle);
        if(!element)
        return;
        if (!document.fullscreenElement) {
            element.requestFullscreen();
            this.setState({
                ...this.state,
                fullScreen:!this.state.fullScreen
            });
        } else {
          if (document.exitFullscreen) {
            element.exitFullscreen(); 
            this.setState({
                ...this.state,
                fullScreen:!this.state.fullScreen
            });
          }
        }
      }

    render() {
      //  this.enterFS();
    return(
        <div>
           <div className="video-img">
                <video  ref={this.videoRef} width="100%" className="video-v" autoPlay id={'video' + this.state.videoTitle} key={this.state.videoTitle} controls controlsList="nodownload" >
                    <source src={this.state.videoUrl} type="video/mp4" />
                </video>
            </div>
            <button
                data-skip="-10"
                className="player__button"
                onClick={this.skip}
            >« 10s
          </button>

            <button
                data-skip="10"
                className="player__button"
                onClick={this.skip}
            >10s »
          </button>

          <button 
            className="player__button toggle" 
            title="Toggle Play"
            onClick={this.togglePlay}>
            { !this.state.videoPlaying ? '►' : '❚ ❚' }
          </button>

          <button 
            className="player__button toggle" 
            title="Toggle Play"
            onClick={this.toggleFullScreen}>
            { !this.state.fullScreen ? 'Full screen' : 'Minimize screen' }
          </button>


          
      
        </div>
    )
        
       
    }
}
